import React, { useState } from "react";
import "./Close_modal.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { closeTrades } from "../../../../utils/apis/buy_and_sell/buy_and_sell";
import Successfull_Modal from "../successfull_modal/Successfull_Modal";
import Deposit_Lottie from "../../../animation/deposit_lottie/Deposit_Lottie";
import { useForm } from "react-hook-form";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Close_modal = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();

  const submitClose = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      const res = await closeTrades(props.closeTradeId, {
        latest_amount: props?.latestAmount,
        quantity: Number(props.closeQuantity),
      });

      if (res?.success) {
        toast.success(`Successfully closed ${props.closeQuantity} lot(s)`, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
        });

        props.getGraphData();

        setTimeout(() => {
          props.onHide(true);
          props.onClose(true);
        }, 2000);
      } else {
        const msg = res?.message || "Transaction failed";
        setError("amount", { message: msg });
        toast.error(msg, { position: "bottom-right" });
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("An error occurred. Please try again.", { position: "bottom-right" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <ToastContainer position="bottom-right" theme="dark" />

      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="close-modal premium-close-modal max-md:scale-[.85] overflow-hidden"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header 
          closeButton 
          className="border-b border-cyan-900/40 bg-gradient-to-r from-slate-950 to-slate-900/95 backdrop-blur-lg"
          closeVariant="white"
        >
          <Modal.Title 
            id="contained-modal-title-vcenter"
            className="text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-cyan-300 to-blue-500 tracking-tight flex items-center gap-4"
          >
            {/* <FontAwesomeIcon icon={faExclamationTriangle} className="text-yellow-400 text-3xl" /> */}
            Close Trade
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="bg-gradient-to-b from-slate-950/95 to-black/95 backdrop-blur-2xl p-10 text-center border-t border-cyan-900/30">
          <div className="space-y-8 max-w-lg mx-auto">
            {/* <div className="warning-icon-wrapper">
              <FontAwesomeIcon 
                icon={faExclamationTriangle} 
                className="text-yellow-400 text-6xl animate-pulse-slow"
              />
            </div> */}

            <h3 className="text-2xl font-bold text-cyan-50 tracking-wide">
              Are you sure you want to close this trade?
            </h3>

            <div className="quantity-badge inline-flex items-center gap-4 px-8 py-5 rounded-2xl bg-slate-900/70 border border-cyan-800/50 backdrop-blur-md shadow-inner shadow-cyan-900/20">
              <span className="text-cyan-300 font-medium text-xl">Quantity:</span>
              <span className="text-4xl font-black text-white drop-shadow-lg">
                {props.closeQuantity}
              </span>
              <span className="text-xl font-semibold text-cyan-200">lot{Number(props.closeQuantity) !== 1 ? 's' : ''}</span>
            </div>

            <p className="text-base text-cyan-400/80 pt-4">
              This action cannot be undone. Your position will be closed at the current market price.
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-t border-cyan-900/40 bg-slate-950/85 px-10 py-8 flex justify-center gap-6 backdrop-blur-lg">
          <Button
            variant="outline-light"
            className="min-w-[160px] px-10 py-4 rounded-2xl border-2 border-cyan-800/60 text-cyan-300 hover:bg-cyan-950/50 hover:border-cyan-400 hover:text-cyan-200 transition-all duration-300 shadow-sm hover:shadow-cyan-500/30 text-lg font-medium"
            onClick={() => props.onHide()}
            disabled={isSubmitting}
          >
            Cancel
          </Button>

          <Button
            className="min-w-[200px] px-12 py-4 rounded-2xl bg-gradient-to-r from-red-600 via-red-500 to-rose-600 hover:from-red-500 hover:to-rose-500 text-white font-bold text-lg shadow-xl shadow-red-600/40 hover:shadow-red-500/60 transform hover:scale-[1.04] active:scale-95 transition-all duration-300 disabled:opacity-60 disabled:scale-100 disabled:shadow-none"
            onClick={submitClose}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Closing Trade..." : "Confirm Close"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Successfull_Modal
        message={`Trade Closed Successfully`}
        show={showModal}
        onHide={() => setShowModal(false)}
        lottie={<Deposit_Lottie />}
      />
    </>
  );
};

export default Close_modal;